export const GCLID = {
  LINKEDIN_ADS: 'LinkedIn Ads',
  PAID_SEARCH: 'Paid Search',
  ORGANIC_SEARCH: 'Organic Search',
};
